var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Route, Routes, Navigate, useMatch } from 'react-router-dom';
import ClientStore from 'stores/ClientStateStore/store';
import Header from './Header';
import Footer from './Footer';
import Games from './Games';
import Score from './Score';
import Expectations from './Expectations';
var Authorized = /** @class */ (function (_super) {
    __extends(Authorized, _super);
    function Authorized() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Authorized.prototype.getFooter = function () {
        var result = '';
        var iOS = false;
        if (window.navigator && window.navigator.userAgent) {
            iOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
        }
        // Semi hacky way to check if user is on an iPad
        // iPadOS 13+ sends user agents that are identical to MacBooks
        // This will check that agent and use maxTouchPoints to determine iPad use
        function isIpad() {
            return navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints > 1;
        }
        if (!iOS && !isIpad()) {
            result = (_jsx(Footer, {}));
        }
        return result;
    };
    Authorized.prototype.render = function () {
        if (!ClientStore.isLoggedIn()) {
            return _jsx(Navigate, { to: "/mobile/login" });
        }
        if (this.props.match.isExact) {
            return _jsx(Navigate, { to: "/mobile/authorized/games" });
        }
        return (_jsxs("div", { children: [_jsx(Header, {}), _jsxs(Routes, { children: [_jsx(Route, { path: "games", element: _jsx(Games, {}) }), _jsx(Route, { path: "score", element: _jsx(Score, {}) }), _jsx(Route, { path: "expectations", element: _jsx(Expectations, {}) })] }), this.getFooter()] }));
    };
    return Authorized;
}(React.Component));
var AuthorizedWrapper = function () {
    var match = useMatch('/mobile/authorized');
    return _jsx(Authorized, { match: { isExact: Boolean(match) } });
};
export default AuthorizedWrapper;
